import { queryLocationsApi } from "../../map/location";
import { IMapMeasuringService } from "../../map/measuring/types";
import { omniaResolve } from "../../promises";
import { IOmniaShell } from "../../shell";
import { IOmniaHttpService, IOmniaSession } from "../../types";
import { RoleId } from "../../user";
import { IFieldsMapContainerContext } from "../map";
import { SharedFieldsService } from "../service";

export class FieldsMapContainerContext implements IFieldsMapContainerContext {
    private _session: IOmniaSession;

    public enableTooltips = true;

    static $inject = [
        "$timeout",
        "$rootScope",
        "$compile",
        "OmniaFieldsService",
        "OmniaMapMeasuringService",
        "OmniaShell",
        "OmniaHttpService",
    ];

    constructor(
        public readonly $timeout: ng.ITimeoutService,
        public readonly $rootScope: ng.IRootScopeService,
        public readonly $compile: ng.ICompileService,
        public readonly fieldSvc: SharedFieldsService,
        public readonly measuringService: IMapMeasuringService,
        public readonly shell: IOmniaShell,
        public readonly http: IOmniaHttpService
    ) {
        this._session = shell.getSession();
    }

    get bingKey() {
        return this._session.bingKey;
    }

    get customBasemaps() {
        const { currentUserRole: role, customBasemaps } = this._session;

        if (role >= RoleId.Master && customBasemaps && customBasemaps.length) {
            return this._session.customBasemaps;
        }
    }

    queryLocationApi(query: string) {
        query = query || "";

        if (query.length < 3) {
            return omniaResolve([]);
        }

        const querySuffix = this.shell.config.features.maps.geolocationQuerySuffix;

        return queryLocationsApi(this.http, query, querySuffix, this.bingKey).then((r) =>
            r.map((l) => ({
                name: l.name,
                bbox4326: {
                    xmin: l.bbox[1],
                    ymin: l.bbox[2],
                    xmax: l.bbox[3],
                    ymax: l.bbox[0],
                },
            }))
        );
    }
}
